import api from '@utils/api';

const ENDPOINT = '/permission-groups';

export const PermissionGroupService = {
    getAll: async () => {
        const response = await api.get(ENDPOINT);
        return response.data?.data || [];
    },

    getById: async (id) => {
        const response = await api.get(`${ENDPOINT}/${id}`);
        return response.data?.data || response.data;
    },

    create: async (data) => {
        const response = await api.post(ENDPOINT, data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`${ENDPOINT}/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        await api.delete(`${ENDPOINT}/${id}`);
        return id;
    },

    getUsers: async (id) => {
        const response = await api.get(`${ENDPOINT}/${id}/users`);
        return response.data?.data || [];
    },

    syncUsers: async (id, userIds) => {
        const response = await api.put(`${ENDPOINT}/${id}/users`, { user_ids: userIds });
        return response.data?.data || [];
    },
};

export const MenuService = {
    getAll: async (params = {}) => {
        const response = await api.get('/menus', { params });
        return response.data?.data || [];
    },

    getById: async (id) => {
        const response = await api.get(`/menus/${id}`);
        return response.data?.data || response.data;
    },

    create: async (data) => {
        const response = await api.post('/menus', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/menus/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        await api.delete(`/menus/${id}`);
        return id;
    },
};

export const AbilityService = {
    getAll: async () => {
        const response = await api.get('/abilities');
        return response.data?.data || [];
    },

    getById: async (id) => {
        const response = await api.get(`/abilities/${id}`);
        return response.data?.data || response.data;
    },

    create: async (data) => {
        const response = await api.post('/abilities', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/abilities/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        await api.delete(`/abilities/${id}`);
        return id;
    },
};
